import React, { useState } from 'react';
import { Box, Typography, Grid, Link, Container } from '@mui/material';

const items = [
  {
    icon: '/images/icon1.svg', 
    title: 'High-Quality Furniture',
    description: 'We provide premium furniture that brings comfort and style to every space.',
    linkText: 'more info',
  },
  {
    icon: '/images/icon2.svg', 
    title: 'Seamless Workflow',
    description: 'Our efficient workflow ensures timely delivery and smooth project management.',
    linkText: 'more info',
  },
  {
    icon: '/images/icon3.svg', 
    title: 'Trusted by Clients',
    description: 'Our clients trust us for reliable service and long-lasting partnerships.',
    linkText: 'more info',
  },
  {
    icon: '/images/icon4.svg', 
    title: 'Expert Craftsmanship',
    description: 'Our team consists of experts who are passionate about what they do.',
    linkText: 'more info',
  },
];

const WhyChooseUs = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleClick = (index) => {
    setSelectedIndex(index);
  };

  return (
    <Container
      maxWidth="100%"
      sx={{
        padding: '80px 0',
        backgroundColor: 'white', // 确保背景为白色
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          textAlign: 'center',
          marginBottom: '40px',
          color: '#333',
        }}
      >
        Why Choosing Us
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {items.map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Box
              onClick={() => handleClick(index)}
              sx={{
                textAlign: 'center',
                padding: '20px',
                borderRadius: '12px',
                transition: 'transform 0.3s ease',
                boxShadow:
                  selectedIndex === index
                    ? '0 0 15px rgba(255, 145, 145, 0.5)'
                    : '0 0 10px rgba(0, 0, 0, 0.05)', // 点击时的阴影效果
                transform: selectedIndex === index ? 'scale(1.05)' : 'none', // 点击放大效果
                border:
                  selectedIndex === index
                    ? '1px solid #fcb8b8'
                    : '1px solid rgba(0, 0, 0, 0.1)', // 激活状态的边框颜色
                '&:hover': { transform: 'scale(1.05)' },
              }}
            >
              <Box
                component="img"
                src={item.icon}
                alt={`${item.title} icon`}
                sx={{
                  width: '50px',
                  height: '50px',
                  marginBottom: '10px',
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 'bold',
                  marginBottom: '10px',
                  color: '#333',
                }}
              >
                {item.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: '#666', marginBottom: '15px' }}
              >
                {item.description}
              </Typography>
              <Link
                href="#"
                underline="none"
                sx={{
                  color: '#F97316',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                }}
              >
                {item.linkText}
              </Link>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default WhyChooseUs;